import React from 'react'

export const CataloghiBlockSettings = (settingsProps) => {
  return (
    <>
      <div className="empty-message">
        <p>No options available</p>
      </div>
    </>
  )
}

export const CataloghiBlockFloatingSettings = () =>
  React.createElement(CataloghiBlockSettings, { floating: true })
